import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { MultiSelectChips, MutliDropdown, SingleDropdown, Table } from "../../../components/shared";
import { Loader } from "../../../components/loaders/loaders";
import { useMessage } from "../../../context/MessageContext";
import { addEditAgentFormSchema } from "../../../components/schema/schema";
import { RootState, AppDispatch } from "../../../redux/store";
import { getApi, postApi } from "../../../apis/api";
import { CustomerRowDataType } from "../../Order-management/CustomerOrder/CustomerOrder-types";
import EmailReportModal from "../../../components/modals/EmailReportModal";
import {
  GET_REPORT_COLUMNS,
  GET_ALL_INVOICE_GROUP,
  REPORT_CUSTOMER_LIST,
} from "../../../apis/end-points";
import ConfirmModal from "../../../components/modals/ConfirmModal";
import SearchInput from "../../../components/shared/SearchInput";
import useFormChangeHandler from "../../../hooks/useFormChangeHandler";
import {
  GENERAL_ERROR_MESSAGE,
  REPORT_MESSAGES,
} from "../../../utils/message";
import { AddReport, ColumnType, ReportColumn, ReportColumns, ReportItem, tableConfig } from "./CreateReport-types";
import SuccessModal from "../../../components/modals/SuccessModal";
import useSearchAndFilter from "../../../hooks/useSearchAndFilter";
import moment from "moment";
import momentTz from "moment-timezone";
import { DropwdownValueTypes } from "../../agent-management/AgentList/AgentListTabs/AgentRateNew/AgentRateTypes";
import { DEFAULT_PAGE_SIZE, CASTELLE_INVOICE_REPORT, CASTELLE_CUSTOMER_NAME } from "../../../utils/constants";
import ErrorModal from "../../../components/modals/ErrorModal";

const mapReportList = (reportList: any[]) => {
  if (!reportList) return [];

  return reportList.map((item: any, index: number) => {
    const customer = item.customer || null;

    // fallback to the first item in customerName[] if available
    const fallbackCustomer = item.customerName?.[0] || {
      name: "",
      customerLevel: "",
    };
    const customerArray = item?.customerName || [];

    return {
      count: item.count,
      id: "/" + item.id,
      createdOn: moment(item?.createdAt?.split("T")[0]).format("MM-DD-YYYY"),
      createdAt: moment(item?.createdAt.split("T")[1], "HH:mm:ss.SSSZ").format(
        "hh:mm A"
      ),
      title: item.title,
      reportCat: item.reportType,
      createdBy:
        item.createdBy !== null
          ? `${item.createdBy.firstName} ${item.createdBy.lastName}`
          : "--",
      customerName: customerArray.length > 1 ?
        customer?.name || fallbackCustomer?.name + "..." || "--" :
        customer?.name || fallbackCustomer?.name || "--",
      // customerType:
      //   customer?.customerLevel || fallbackCustomer.customerLevel
      //     ? fallbackCustomer.customerLevel === "first"
      //       ? "Direct Customer"
      //       : fallbackCustomer.customerLevel === "second"
      //       ? "Parent Customer"
      //       : fallbackCustomer.customerLevel === "third"
      //       ? "Sub Customer"
      //       : "--"
      //     : "--",
      scheduling: item.scheduling,
      type: item.type,
      reportURL: item.reportURL,
      reportDateType: item.reportDateType ?? "--",
      tooltip: item?.customerName?.map((e: any) => e?.name),
    };
  });
};
const CreateReport: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setMessage } = useMessage();
  const [formData, setFormData] = useState<AddReport>();
  const [columnData, setColumnData] = useState<ReportColumn[]>([]);
  const [reportData, setReportData] = useState<any>([]);
  const [askEmail, setAskEmail] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const today = moment().format("MM-DD-YYYY");
  const afterOneYear = moment().add(1, "year").format("MM-DD-YYYY");
  const maxDate = moment().format("YYYY-MM-DD");
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<ReportColumn[]>([{
    "id": "N2GrsiqUJ5A",
    "updatedAt": "2024-11-27T12:23:34.000Z",
    "createdAt": "2024-11-27T12:00:59.000Z",
    "title": "Order Number",
    "key": "orderNumber",
    "isActive": true
  }]);
  const [success, setSuccess] = useState(false);
  const [saveAndSend, setSaveAndSend] = useState(false);
  const [errorReport, setErrorReport] = useState<string>("");
  const { data, fetchFilteredData, fetchWithCurrentFilters, loading, setLoading } = useSearchAndFilter({
    apiUrl: "/report",
    limit: 5,
    bindToGlobalPage: false,
    mapUserData: mapReportList,
    extentedUrl: "&type=recent",
  })
  const { isUserOfOmniMove } = useSelector(
    (state: RootState) => state.auth
  );
  const { reportTypeStatic } = useSelector((state: RootState) => state.staticData);
  const locationStateData = useSelector(
    (state: RootState) => state.locationState.locationStateData
  );
  const [customerSelected, setCustomerSelected] = useState<
    DropwdownValueTypes[]
  >([]);
  const [associatedCustomerSelected, setAssociatedCustomerSelected] = useState<
    DropwdownValueTypes[]
  >([]);
  const [assCustomerNameDropdown, setAssCustomerNameDropdown] = useState<
    CustomerRowDataType[]
  >([]);
  const [assCustomerRowData, setAssCustomerRowData] =
    useState<CustomerRowDataType>({
      id: "",
      name: "",
      customerNumber: "",
      customerLevel: "",
    });
  const [filteredColumnData, setFilteredColumnData] = useState<ReportColumn[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const reportSchedulingOptions = ["Month", "Week", "Daily"];
  const reportTypeOptions = ["All", "Custom"];
  const [reportType, setReportType] = useState("");
  const [reportScheduling, setReportScheduling] = useState("");
  const [customerNameDropdown, setCustomerNameDropdown] = useState<
    CustomerRowDataType[]
  >([]);
  const [customerRowData, setCustomerRowData] = useState<CustomerRowDataType>({
    id: "",
    name: "",
    customerNumber: "",
    customerLevel: "",
  });
  const [customerList, setCustomerList] = useState<string[]>([]);
  // Invoice Group single-select dropdown (non-mandatory). Columns are placeholder
  // (id/name/other) until the allInvoiceGroup response fields are finalized.
  const [invoiceGroupDropdownData, setInvoiceGroupDropdownData] = useState<any[]>([]);
  const [invoiceGroupRowData, setInvoiceGroupRowData] = useState<any>(null);
  // When an invoice group is selected, the Customer / Sub-Customer dropdowns switch
  // their data source to REPORT_CUSTOMER_LIST and are scoped by the invoice group.
  const isInvoiceGroupSelected = !!invoiceGroupRowData?.id;
  // Track a deferred "default to all" per dropdown, applied once the list first
  // loads with data after an invoice group is selected (avoids the "all" flicker).
  const pendingCustomerAllRef = useRef<boolean>(false);
  const pendingSubAllRef = useRef<boolean>(false);
  // Scope key (parent Customer / Invoice Group) that the Sub-Customer prune last
  // ran for. Used to prune stale sub-selections only when the parent scope truly
  // changes — not on dropdown refetches from search/pagination (which hold a
  // single page and would wrongly drop valid selections on a later page).
  const lastSubPrunedScopeRef = useRef<string | null>(null);
  const [initialValues, setInitialValues] = useState<AddReport>({
    title: "",
    type: "",
    scheduling: "",
    todate: today,
    fromDate: afterOneYear,
    customerId: [],
    associatedCustomerId: [],
    notificationEmails: [],
    templateColumn: [],
    save: true,
    reportCategory: "",
    filterDateRangeName: "order",
  });
  const [formValues, setFormValues] = useState<AddReport>({
    title: "",
    type: "",
    scheduling: "",
    todate: "",
    fromDate: "",
    customerId: [],
    associatedCustomerId: [],
    notificationEmails: [],
    templateColumn: [],
    save: true,
    reportCategory: "",
    filterDateRangeName: "order",
  });
  const columns: ColumnType[] = ReportColumns;
  const {
    checkInputChange,
    handleConfirmNavigation,
    handleCancelNavigation,
    showModal,
    handleUpdateNavigation,
  } = useFormChangeHandler();
 
  const REPORT_CATEGORY_COLUMN_LOCKS: { [categoryId: string]: string[] } = reportTypeStatic.reduce(
    (acc: any, report: any) => {
      acc[report.id] = report.field;
      return acc;
    },
    {} as { [key: string]: string[] }
  );
  const [lockedColumnKeys, setLockedColumnKeys] = useState<string[]>([]);
  const [filterDateRangeName, setFilterDateRangeName] = useState<string>("order");

  const DATE_RANGE_ALL_OPTIONS: { label: string; value: string }[] = [
    { label: "Order Date", value: "order" },
    { label: "Delivered Status Date", value: "deliver" },
    { label: "Invoice Date", value: "invoice" },
  ];

  // Normalize any casing/spacing variant from the API to a plain lowercase key
  const normalizeDateKey = (s: string) => s.toLowerCase().replace(/[^a-z]/g, "");

  const DATE_RANGE_NORMALIZED_MAP: Record<string, string> = {
    invoice: "invoice",
    invoicedate: "invoice",
    order: "order",
    orderdate: "order",
    deliver: "deliver",
    delivereddate: "deliver",
    deliverydate: "deliver",
    deliveredstatusdate: "deliver",
  };

  // Map categoryId → allowed date range values derived from dateRangeFilterName array
  const REPORT_CATEGORY_DATE_RANGE: { [categoryId: string]: string[] } = reportTypeStatic.reduce(
    (acc: any, report: any) => {
      const names: string[] = report.dateRangeFilterName || [];
      acc[report.id] = names
        .map((name: string) => DATE_RANGE_NORMALIZED_MAP[normalizeDateKey(name)])
        .filter(Boolean);
      return acc;
    },
    {} as { [key: string]: string[] }
  );

  // Map categoryId → default selected value from defaultDateRangeFilterName[0]
  const REPORT_CATEGORY_DEFAULT_DATE: { [categoryId: string]: string } = reportTypeStatic.reduce(
    (acc: any, report: any) => {
      const defaultName: string = (report.defaultDateRangeFilterName || [])[0] || "";
      acc[report.id] = DATE_RANGE_NORMALIZED_MAP[normalizeDateKey(defaultName)] ?? "order";
      return acc;
    },
    {} as { [key: string]: string }
  );

  const [availableDateRangeOptions, setAvailableDateRangeOptions] = useState<{ label: string; value: string }[]>([]);
  const formatToUTC = (date: string): string => {
    return moment(date).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
  };
  const [selectReportCatagory, setSelectReportCatagory] = useState<any>({ id: "", name: "" })
  // Reports where the backend already supplies "Order Number", so the frontend must
  // not force-select it. It starts unselected but the user may still pick it.
  const ORDER_NUMBER_OPTIONAL_REPORTS = ["Invoice Report", "Invoice Order Report"];
  const isOrderNumberExcluded = ORDER_NUMBER_OPTIONAL_REPORTS.includes(
    selectReportCatagory?.name
  );
  const handleDropdownChange = (fieldName: string, selectedItem: any) => {
    const selectedCategoryId = selectedItem?.id || "";
    setSelectReportCatagory({
      id: selectedCategoryId,
      name: selectedItem?.name || "",
    });
    const lockedKeys = REPORT_CATEGORY_COLUMN_LOCKS[selectedCategoryId] || [];
    setLockedColumnKeys(lockedKeys);

    // Get the full column data for the locked ones
    const lockedCols = columnData.filter((col) => lockedKeys.includes(col.key));

    // Always include "Order Number" if it's in the list
    const orderNumberColumn = columnData.find((col) => col.title === "Order Number");

    const newSelection = [...lockedCols];
    // Skip auto-selecting Order Number for reports where it is optional.
    if (
      orderNumberColumn &&
      !ORDER_NUMBER_OPTIONAL_REPORTS.includes(selectedItem?.name || "")
    ) {
      newSelection.unshift(orderNumberColumn);
    }

    setSelectedColumns(newSelection);

    // Filter date range options to only those present in the category's dateRangeFilterName
    const allowedValues = REPORT_CATEGORY_DATE_RANGE[selectedCategoryId] ?? [];
    const filtered = DATE_RANGE_ALL_OPTIONS.filter((o) => allowedValues.includes(o.value));
    setAvailableDateRangeOptions(filtered);
    if (filtered.length > 0) {
      const defaultValue = REPORT_CATEGORY_DEFAULT_DATE[selectedCategoryId] ?? filtered[0].value;
      setFilterDateRangeName(defaultValue);
    }
  };

  const isSaveDisabled = (value: any) => {
    let status = false;
    // Customer / Sub-Customer are optional; only title, type and date range are required.
    if (value.title === "") status = true;
    if (reportType === "") status = true;
    if (value.fromDate === "") status = true;
    if (value.todate === "") status = true;
    return status;
  }

  const isSecondLevelCustomerSelected =
    customerSelected.some((c) => c.id === "all") ||
    customerSelected.some((c) => c.customerLevel === "second");
  const updateCustomerList = (data: any) => {
    if (data !== null && data !== "") {
      setCustomerList((prevData) => {
        const updatedList = new Set([...prevData, data]); // Use Set to ensure uniqueness
        return Array.from(updatedList); // Convert back to array
      });
    }
  };
  const reSetDates = (values: AddReport = formValues) => {
    values.fromDate = "";
    values.todate = "";
  }

  const handleSubmit = async (values: AddReport = formValues) => {
    try {
      setLoading(true);
      let apiResponse;
      const isAllCustomersSelected = customerSelected.some(
        (item) => item.id === "all"
      );
      const isAllSubCustomersSelected = associatedCustomerSelected.some(
        (item) => item.id === "all"
      );

      values.customerId = isAllCustomersSelected
        ? ["all"]
        : customerSelected.map((item) => item.id).filter((id) => id !== "all");

      values.associatedCustomerId = isAllSubCustomersSelected
        ? ["all"]
        : associatedCustomerSelected.map((item) => item.id).filter((id) => id !== "all");

      values['templateColumn'] = selectedColumns;
      values['fromDate'] = formatToUTC(
        `${moment(values.fromDate).format("YYYY-MM-DD")}T00:00:00Z`
      );
      values['todate'] = formatToUTC(
        `${moment(values.todate).format("YYYY-MM-DD")}T23:59:59`
      );
      values['reportCategory'] = selectReportCatagory?.name;
      values['filterDateRangeName'] = filterDateRangeName;
      values['invoiceGroupId'] = invoiceGroupRowData?.id ? [invoiceGroupRowData.id] : [];
      const apiPayload = { ...values, timeZone: momentTz.tz.guess() };
      apiResponse = await postApi<any>("/report", apiPayload);

      if (apiResponse.success) {
        if(apiResponse?.data?.error) {
          setErrorReport(apiResponse.data.error);
            setTimeout(() => {
               setErrorReport("");
           }, 2000);
        }
        else{
          setErrorReport("");
          if (values["notificationEmails"].length > 0) {
          setSaveAndSend(true);
          setTimeout(() => {
            setSaveAndSend(false);
          }, 2000);
        }
        else {
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 2000);
        }
      }
    
        setCustomerList([]);
        setFilterDateRangeName("order");
        setSelectReportCatagory({ id: "", name: "" });
        setSelectedColumns([{
          "id": "N2GrsiqUJ5A",
          "updatedAt": "2024-11-27T12:23:34.000Z",
          "createdAt": "2024-11-27T12:00:59.000Z",
          "title": "Order Number",
          "key": "orderNumber",
          "isActive": true
        }]);
        setCustomerRowData({
          id: "",
          name: "",
          customerNumber: "",
          customerLevel: "",
        });
        setAssCustomerRowData({
          id: "",
          name: "",
          customerNumber: "",
          customerLevel: "",
        });
        setCustomerSelected([]);
        setAssociatedCustomerSelected([]);
        setInvoiceGroupRowData(null);
        setIsSelectAll(false);
        setReportType("");
        setReportScheduling("");
        values["title"] = "";
        values["notificationEmails"] = [];
        handleUpdateNavigation();
        setAskEmail(false);
      } else {
        // Not-success response (e.g. "No customer selected for report generation.")
        // — surface the backend message in the error popup.
        setErrorReport(apiResponse.error?.message || GENERAL_ERROR_MESSAGE);
        setTimeout(() => {
          setErrorReport("");
        }, 2000);
      }
    } catch (error) {
      setMessage(GENERAL_ERROR_MESSAGE, "error");
    } finally {
      setLoading(false);
      fetchFilteredData();
    }
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);
    setFilteredColumnData(columnData.filter((data: any) => data.title.toLowerCase().includes(query)));
  }


  const getColumnData = async () => {
    const apiResponse = await getApi<any>(GET_REPORT_COLUMNS);
    if (apiResponse.success) {
      setColumnData(apiResponse.data);
      setFilteredColumnData(apiResponse.data);
    }
  };

  useEffect(() => {
    getColumnData();
  }, []);

  useEffect(() => {
    if (isUserOfOmniMove === true) {
      setCustomerNameDropdown(locationStateData?.addedByTenants ?? []);
    }
  }, []);

  useEffect(() => {
    // In invoice-group mode the Sub-Customer list is independent of the Customer
    // selection, so don't clear it just because Customer became empty.
    if (!isInvoiceGroupSelected && customerSelected.length === 0) {
      setAssociatedCustomerSelected([]);
      setAssCustomerRowData({ id: "", name: "", customerNumber: "", customerLevel: "" });
    }
    if (!isCastelleReportVisible && selectReportCatagory.name === CASTELLE_INVOICE_REPORT) {
      setSelectReportCatagory({ id: "", name: "" });
      setLockedColumnKeys([]);
    }
  }, [customerSelected, associatedCustomerSelected]);

  // On invoice-group change, clear both selections and defer defaulting them to
  // "all" until each list first loads with data. On clear, just revert to empty.
  useEffect(() => {
    setCustomerSelected([]);
    setAssociatedCustomerSelected([]);
    setAssCustomerRowData({ id: "", name: "", customerNumber: "", customerLevel: "" });
    pendingCustomerAllRef.current = isInvoiceGroupSelected;
    pendingSubAllRef.current = isInvoiceGroupSelected;
  }, [invoiceGroupRowData?.id]);

  // Apply the deferred "all" for Customer once its list first loads — only if data
  // is present; otherwise leave it empty. Runs once per invoice-group selection.
  useEffect(() => {
    if (!pendingCustomerAllRef.current) return;
    if (customerNameDropdown.length > 0) {
      setCustomerSelected([{ id: "all", name: "all" }]);
    }
    pendingCustomerAllRef.current = false;
  }, [customerNameDropdown]);

  // Apply the deferred "all" for Sub-Customer once its list first loads — only if
  // data is present; otherwise leave it empty. Runs once per invoice-group selection.
  useEffect(() => {
    if (!pendingSubAllRef.current) return;
    if (assCustomerNameDropdown.length > 0) {
      setAssociatedCustomerSelected([{ id: "all", name: "all" }]);
    }
    pendingSubAllRef.current = false;
  }, [assCustomerNameDropdown]);

  useEffect(() => {
    if (customerSelected.length === 0) return;
    // Identify the current parent scope. In invoice-group mode the Sub-Customer
    // list is scoped by the invoice group; otherwise by the selected Customer(s).
    const scopeKey = isInvoiceGroupSelected
      ? `ig:${invoiceGroupRowData?.id ?? ""}`
      : customerSelected.some((c) => c.id === "all")
        ? "all"
        : customerSelected.map((c: any) => c.id).join(",");
    // Only prune stale sub-customer selections when the parent scope actually
    // changes. Skipping equal scopes prevents search/pagination refetches (which
    // replace assCustomerNameDropdown with a single page) from dropping a valid
    // selection that lives on a later page.
    if (lastSubPrunedScopeRef.current === scopeKey) return;
    lastSubPrunedScopeRef.current = scopeKey;
    setAssociatedCustomerSelected((prev) =>
      prev.filter(
        (selected) =>
          (selected.id === "all" && assCustomerNameDropdown.length > 0) ||
          assCustomerNameDropdown.some((d: any) => d.id === selected.id)
      )
    );
  }, [assCustomerNameDropdown]);

  const isSubCustomerDisabled = customerSelected.length === 0;

  const isCastelleReportVisible =
    customerSelected.length > 0 &&
    !customerSelected.some((c) => c.id === "all") &&
    customerSelected.every((c) => c.name?.toLowerCase() === CASTELLE_CUSTOMER_NAME.toLowerCase()) &&
    (associatedCustomerSelected.length === 0 || (
      !associatedCustomerSelected.some((c) => c.id === "all") &&
      associatedCustomerSelected.every((c) => c.name?.toLowerCase() === CASTELLE_CUSTOMER_NAME.toLowerCase())
    ));

  const filteredReportTypeStatic = reportTypeStatic
    .map(({ id, name }: { id: string; name: string }) => ({ id, name }))
    .filter(({ name }: { name: string }) =>
      isCastelleReportVisible ? true : name !== CASTELLE_INVOICE_REPORT
    );


  useEffect(() => {
    if (reportType === "Custom") {
      setIsCustom(true)
      initialValues["fromDate"] = "";
      initialValues["todate"] = "";
    }
    else {
      setIsCustom(false);
      initialValues["fromDate"] = today;
      initialValues["todate"] = afterOneYear;
    }
  }, [reportType])

  useEffect(() => {
    setCustomerList([]);
    customerSelected.map((item) => {
      const data = item.id;
      updateCustomerList(data);
    })
    associatedCustomerSelected.map((item) => {
      const data = item.id;
      updateCustomerList(data);
    })
  }, [customerSelected, associatedCustomerSelected]);

  // const handleCheckboxChange = (item: { id: number; title: string }) => {
  //   setSelectedColumns((prev:any) => {
  //     if (item.title === "Order Number") {
  //       return prev;
  //     }

  //     const alreadySelected = prev.some((selected:any) => selected.id === item.id);

  //     if (alreadySelected) {
  //       return prev.filter((selected:any) => selected.id !== item.id);
  //     } else {
  //       return [...prev, item];
  //     }
  //   });
  // };
  const handleCheckboxChange = (item: ReportColumn) => {
    // Prevent changes to locked columns and "Order Number" (unless Order Number
    // is optional for the selected report).
    if (
      (item.title === "Order Number" && !isOrderNumberExcluded) ||
      lockedColumnKeys.includes(item.key)
    ) {
      return;
    }

    setSelectedColumns((prev: ReportColumn[]) => {
      const alreadySelected = prev.some((selected) => selected.key === item.key);

      if (alreadySelected) {
        // Remove the column if it's already selected and not locked
        return prev.filter((selected) => selected.key !== item.key);
      } else {
        // Add the column to selected list
        return [...prev, item];
      }
    });
  };

  const handleSelectAll = () => {
    const selectableItems = columnData.filter(
      (item: any) =>
        (item.title !== "Order Number" || isOrderNumberExcluded) &&
        !lockedColumnKeys.includes(item.key)
    );

    const allSelected = selectableItems.every((item: any) =>
      selectedColumns.some((selected: any) => selected.key === item.key)
    );

    if (allSelected) {
      setSelectedColumns((prev: any) =>
        prev.filter(
          (item: any) =>
            (item.title === "Order Number" && !isOrderNumberExcluded) ||
            lockedColumnKeys.includes(item.key)
        )
      );
    } else {
      setSelectedColumns((prev: any) => {
        const preserved = prev.filter(
          (item: any) =>
            (item.title === "Order Number" && !isOrderNumberExcluded) ||
            lockedColumnKeys.includes(item.key)
        );
        return [...preserved, ...selectableItems];
      });
    }
  };

  const isAllSelected = columnData
    .filter((item: any) => item.title !== "Order Number" || isOrderNumberExcluded)
    .every((item: any) =>
      selectedColumns.some((selected) => selected.id === item.id)
    );


  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={addEditAgentFormSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, values, touched, handleChange, setFieldValue }) => (
          <>
            <Form onChange={checkInputChange}>
              <div className="details">
                <div className="form form--innersec">
                  <section className="form__section">
                    <h1 className="form__section__title">Report Details</h1>
                    <div className="formRow formRow__3">
                      <div className="formCol">
                        <MutliDropdown
                          columns={[{ key: "name", title: "Invoice group" }]}
                          data={invoiceGroupDropdownData}
                          setData={setInvoiceGroupDropdownData}
                          rowData={invoiceGroupRowData}
                          setRowData={setInvoiceGroupRowData}
                          displayColumn="name"
                          captionTitles="Select"
                          labelTitle="Invoice Group"
                          apiUrl={GET_ALL_INVOICE_GROUP}
                          enableRemove={true}
                          checkInputChange={checkInputChange}
                        />
                      </div>
                      <div className="formCol">
                        <MultiSelectChips
                          // Remount on invoice-group change so the dropdown refetches
                          // with the new data source / params.
                          key={`customer-${invoiceGroupRowData?.id || "default"}`}
                          apiUrl={isUserOfOmniMove ? "" : REPORT_CUSTOMER_LIST}
                          dropdownData={customerNameDropdown}
                          selectedData={customerSelected}
                          setDropdownData={setCustomerNameDropdown}
                          setSelectedData={setCustomerSelected}
                          searchPlaceholder="Search"
                          labelTitle="Customer"
                          keyBindName="name"
                          limitSelection={Infinity}
                          includeAllOption={true}
                          skipOpenRefetchIfLoaded={true}
                          extendedUrl={
                            isInvoiceGroupSelected
                              ? {
                                  isParent: "true",
                                  isInvoiceGroupSelected: "true",
                                  invoiceGroupId: invoiceGroupRowData.id,
                                }
                              : { isParent: "true" }
                          }
                        />
                      </div>
                      <div className="formCol">
                        <MultiSelectChips
                          // Remount on invoice-group change so the dropdown refetches
                          // with the new data source / params.
                          key={`subcustomer-${invoiceGroupRowData?.id || "default"}`}
                          apiUrl={REPORT_CUSTOMER_LIST}
                          dropdownData={assCustomerNameDropdown}
                          selectedData={associatedCustomerSelected}
                          setDropdownData={setAssCustomerNameDropdown}
                          setSelectedData={setAssociatedCustomerSelected}
                          labelTitle="Sub Customer"
                          keyBindName="name"
                          skipOpenRefetchIfLoaded={true}
                          // In invoice-group mode the list is scoped by the invoice group
                          // alone, so it stays enabled and independent of the Customer
                          // selection; otherwise it requires a parent customer.
                          disable={isInvoiceGroupSelected ? false : isSubCustomerDisabled}
                          parentCustomerId={
                            isInvoiceGroupSelected
                              ? undefined
                              : customerSelected.some((c) => c.id === "all")
                                ? "all"
                                : customerSelected.map((c: any) => c.id).join(",")
                          }
                          limitSelection={Infinity}
                          skipApiCallWhenNoParent={!isInvoiceGroupSelected}
                          includeAllOption={true}
                          extendedUrl={
                            isInvoiceGroupSelected
                              ? {
                                  isParent: "false",
                                  isInvoiceGroupSelected: "true",
                                  invoiceGroupId: invoiceGroupRowData.id,
                                }
                              : { isParent: "false" }
                          }
                        />
                      </div>
                    </div>
                    <div className="formRow formRow__3">
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">
                            Report Title <span className="mandatory-mark">*</span>
                          </label>
                          <Field
                            type="text"
                            id="title"
                            name="title"
                            value={values.title.trimStart()}
                            className={`form__input form__input--sm ${id ? "form__input--disabled" : ""
                              }`}
                            placeholder="Report Title"
                            disabled={id}
                          />
                        </div>
                      </div>
                      {/* <div className="formCol">
                      <div className="form__Field">
                        <label className="form__label">
                          Report Scheduling
                        </label>
                        <select
                          id="scheduling"
                          name="scheduling"
                          className="form__select form__select--sm"
                          value={reportScheduling}
                          onChange={(e) => {
                            values.scheduling = e.target.value;
                            setReportScheduling(e?.target?.value);
                          }}
                        >
                          <option>-Select-</option>
                          {reportSchedulingOptions.map((item: any) => (
                            <option
                              key={`key-agent-type-${item}`}
                              value={item}
                            >
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div> */}
                      <div className="formCol">
                        <SingleDropdown
                          fieldName="packageType"
                          selectedItem={selectReportCatagory}
                          setSelectedData={handleDropdownChange}
                          enableRemove={true}
                          staticData={filteredReportTypeStatic}
                          labelTitle="Report Category"
                          placeholder="-Select-"
                          keyBindName="name"
                          // disable={!isEditable}
                          customStyle={{ minWidth: "1px" }}
                        // isFocused = {isFocus}
                        />
                      </div>
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">
                            Report Type <span className="mandatory-mark">*</span>
                          </label>
                          <select
                            id="type"
                            name="type"
                            className="form__select form__select--sm"
                            value={reportType}
                            onChange={(e) => {
                              values.type = e.target.value;
                              setReportType(e.target.value);
                              if (e.target.value === "Custom") reSetDates(values);
                              else {
                                values["fromDate"] = today;
                                values["todate"] = afterOneYear;
                              }
                            }}
                          >
                            <option>-Select-</option>
                            {reportTypeOptions.map((item: any) => (
                              <option
                                key={`key-report-type-${item}`}
                                value={item}
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                          <span className="form__error">
                          </span>
                        </div>
                      </div>
                    </div>
                    {selectReportCatagory?.id && availableDateRangeOptions.length > 0 && (
                      <div className="formRow formRow__1">
                        <div className="formCol">
                          <div className="form__Field">
                            <label className="form__label">Select Report Date Type</label>
                            <div
                              className="form__radio form__radio--inline"
                              style={{ display: "flex", alignItems: "center", gap: "16px", height: "40px" }}
                            >
                              {availableDateRangeOptions.map((option) => (
                                <div
                                  className="form__radio__option"
                                  key={option.value}
                                  style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: 0 }}
                                >
                                  <input
                                    type="radio"
                                    id={`dateRange-${option.value}`}
                                    name="filterDateRangeName"
                                    className="form__radio__input"
                                    value={option.value}
                                    checked={filterDateRangeName === option.value}
                                    onChange={() => setFilterDateRangeName(option.value)}
                                    style={{ margin: 0 }}
                                  />
                                  <label
                                    htmlFor={`dateRange-${option.value}`}
                                    className="form__radio__label"
                                    style={{ margin: 0, whiteSpace: "nowrap" }}
                                  >
                                    {option.label}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </section>
                  {isCustom &&
                    <section className="form__section">
                      <h1 className="form__section__title">Select Date Range</h1>
                      <div className="formRow formRow__1">
                        <div className="formRow formRow__4">
                          <div className="form__Field">
                            <label htmlFor="fromDate" className="form__label">
                              From Date <span className="mandatory-mark">*</span>
                            </label>
                            <Field
                              type="date"
                              id="fromdate"
                              name="fromDate"
                              className={`form__input form__input--sm ${id ? "form__input--disabled" : ""
                                }`}
                              max={values.todate !== "" ? values.todate || undefined : maxDate}
                              disabled={id}
                              onFocus={(e: any) => {
                                if (typeof e.target.showPicker === "function") {
                                  try {
                                    e.target.showPicker();
                                  } catch (error) {
                                    console.error("showPicker requires a user gesture", error);
                                  }
                                }
                              }}
                            />
                          </div>
                          <div className="form__Field">
                            <label htmlFor="toDate" className="form__label">
                              To Date <span className="mandatory-mark">*</span>
                            </label>
                            <Field
                              type="date"
                              id="todate"
                              name="todate"
                              className={`form__input form__input--sm ${id ? "form__input--disabled" : ""
                                }`}
                              min={values.fromDate || undefined}
                              max={maxDate}
                              disabled={id}
                              onFocus={(e: any) => {
                                if (typeof e.target.showPicker === "function") {
                                  try {
                                    e.target.showPicker();
                                  } catch (error) {
                                    console.error("showPicker requires a user gesture", error);
                                  }
                                }
                              }}
                            /></div>
                        </div>
                      </div>
                    </section>}
               
                  <section className="form__section">
                    { selectReportCatagory?.name !== CASTELLE_INVOICE_REPORT && (
                      <>
                    <h1 className="form__section__title">Select Report Columns</h1>
                    <div className="formRow formRow__2">
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          value={searchTerm}
                          placeholder="Search a name"
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                    <div className="formRow mb_0">
                      <div className="formCol">
                        <div className="form__Field">
                          <div className="form__checkbox form__checkbox--blue">
                            <div className="form__checkbox__option" >
                              <input
                                type="checkbox"
                                className="form__checkbox__input"
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                              />
                              <label htmlFor="billtodickerson" className="form__checkbox__label">Select All</label>
                            </div>
                            {/* {filteredColumnData.map((data: any) => (
                        <div className="form__checkbox__option" key={data.id}>
                            <input type="checkbox" id="billtodickerson" className="form__checkbox__input" 
                            checked={data.title === "Order Number" ||selectedColumns.some((selected: any) => selected.id === data.id)}
                            onChange={() => handleCheckboxChange(data)} />
                            <label htmlFor="billtodickerson" className="form__checkbox__label">{data.title}</label>
                        </div>
                        ))} */}
                            {filteredColumnData.map((data: any) => (
                              <div className="form__checkbox__option" key={data.id}>
                                <input
                                  type="checkbox"
                                  id={`column-checkbox-${data.id}`}
                                  className="form__checkbox__input"
                                  checked={
                                    (data.title === "Order Number" && !isOrderNumberExcluded) ||
                                    selectedColumns.some((selected: any) => selected.key === data.key)
                                  }
                                  onChange={() => handleCheckboxChange(data)}
                                  disabled={(data.title === "Order Number" && !isOrderNumberExcluded) || lockedColumnKeys.includes(data.key)}
                                />
                                <label
                                  htmlFor={`column-checkbox-${data.id}`}
                                  className="form__checkbox__label"
                                >
                                  {data.title}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                     </>
                    )}
                    <div className="btn__group">
                      <button
                        className="btn btn__white"
                        type="button"
                        onClick={() => {
                          navigate("/saved-reports");
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn__primary"
                        type="submit"
                        onClick={() => handleSubmit(values)}
                        disabled={isSaveDisabled(values)}
                      >
                        {"Save"}
                      </button>
                      <button
                        className="btn btn__primary"
                        type="submit"
                        onClick={() => setAskEmail(true)}
                        disabled={isSaveDisabled(values)}
                      >
                        {"Save & Send"}
                      </button>
                    </div>
                  </section>
                  {askEmail && (
                    <EmailReportModal
                      setConfirmModal={setAskEmail}
                      handleSubmit={handleSubmit}
                      values={values}
                      data={[]}
                      setData={setFormData}
                      rowData={[]}
                      rowIndex={1}
                    />
                  )}
                  {
                    errorReport && !loading && (
                    <>
                      <ErrorModal message={errorReport ?? GENERAL_ERROR_MESSAGE} />
                    </>
                    )
                  }
                  {success && !loading && (
                    <SuccessModal message={REPORT_MESSAGES.SAVE_SUCCESS} />
                  )}
                  {saveAndSend && !loading && (
                    <SuccessModal
                      message={REPORT_MESSAGES.SAVE_AND_SEND_SUCCESS}
                    />
                  )}
                  <section className="form__section">
                    <h1 className="form__section__title">Reports</h1>
                    <div className="tableWrap">
                      <div className="tableWrap__head">
                        <div className="formRow" style={{ width: "100%" }}>
                          <Table
                            columns={columns}
                            data={data}
                            setLoading={setLoading}
                            getApiData={fetchWithCurrentFilters}
                            deleteIcon={true}
                            downlaodIcon={true}
                            onDeleteConfig={tableConfig.delete}
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
      {loading && <Loader />}

      {showModal && (
        <ConfirmModal
          confirmInfo={{
            heading: "Unsaved Changes!",
            para: "You have not saved your changes, do you want to continue",
          }}
          onConfirm={handleConfirmNavigation}
          setConfirmModal={handleCancelNavigation}
          firstMessageShow={true}
        />
      )}
    </>
  );
};

export default CreateReport;
